import React from "react";
import { format } from "date-fns";
import assets from "../../assets/assets";


function HolidayList({ holidaysArray, handleShowHolidaysClose }) {
    return <div>
        <div className='container_holidays'>
            <div className="holiday-viewer overflow-y-scroll relative">
                <img
                    src={assets.CrossIcon}
                    alt=""
                    onClick={handleShowHolidaysClose}
                    className="position-absolute top-0 end-0 m-1"
                    style={{ cursor: "pointer", width: "25px", height: "25px" }}
                />
                <div className="border rounded shadow-sm">
                    <div
                        className="d-flex justify-content-between align-items-center text-white p-3 rounded-top"
                        style={{ backgroundColor: "#f57c00" }}
                    >
                        <h6 className="mb-0 fw-bold">List of Holidays</h6>
                    </div>

                    <div
                        className="p-3 orange-scrollBar"
                        style={{ height: "310px", overflowY: "auto" }}
                    >
                        {holidaysArray && holidaysArray.length > 0 ? (
                            holidaysArray.map((holiday, idx) => {
                                const start = new Date(holiday.startDate);
                                const end = new Date(holiday.endDate);

                                const isSameDay =
                                    start.toDateString() === end.toDateString();

                                const formatDateBox = (dateObj) => {
                                    const month = format(dateObj, "MMM").toUpperCase();
                                    const day = format(dateObj, "dd");
                                    const year = format(dateObj, "yyyy");
                                    const dayName = format(dateObj, "EEEE");

                                    return (
                                        <div className="bg-light rounded px-2 py-1 text-center me-1 ms-1">
                                            <div
                                                className="text-uppercase"
                                                style={{ color: "#f57c00", fontSize: "0.65rem" }}
                                            >
                                                {month}
                                            </div>
                                            <div className="fw-bold">{day}</div>
                                            <div
                                                className="text-muted"
                                                style={{ fontSize: "0.65rem", lineHeight: "1rem" }}
                                            >
                                                {dayName}, {year}
                                            </div>
                                        </div>
                                    );
                                };

                                return (
                                    <div
                                        key={idx}
                                        className="d-flex justify-content-between align-items-center rounded p-2 mb-2 shadow-sm bg-white border"
                                    >
                                        <span className="fw-semibold">{holiday.name}</span>
                                        <span className="d-flex align-items-center">
                                            {formatDateBox(start)}
                                            {!isSameDay && (
                                                <span className="fw-bold px-1">–</span>
                                            )}
                                            {!isSameDay && formatDateBox(end)}
                                        </span>
                                    </div>
                                );
                            })
                        ) : (
                            <p className="text-muted">No holidays found.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}

export default HolidayList;
